import { render, staticRenderFns } from "./orderShopInfo.vue?vue&type=template&id=36004997&scoped=true"
import script from "./orderShopInfo.vue?vue&type=script&lang=js"
export * from "./orderShopInfo.vue?vue&type=script&lang=js"
import style0 from "./orderShopInfo.vue?vue&type=style&index=0&id=36004997&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36004997",
  null
  
)

export default component.exports